import React from 'react';
import { Radio } from 'antd';

type TOption<T> = {
  label: React.ReactNode;
  value: T;
};
interface BaseRadioRadioProps<T> {
  options: TOption<T>[];
  name: string;
  value: T;
  className?: string;
  disabled?: boolean;
  onChange?: (v: T) => void;
}

const BaseRadioGroup = <T,>({
  options,
  className,
  name,
  value,
  disabled,
  onChange,
}: BaseRadioRadioProps<T>) => {
  return (
    <Radio.Group
      options={options}
      name={name}
      value={value}
      className={className}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.value)}
    />
  );
};
export default BaseRadioGroup;
